<template>
  <div>
    <ul class="disbursements-wrapper">
      <DisbursementSummaryItem
        v-for="d in disbursementSummaries"
        :key="d.id"
        :header="d.header"
        :details="d.details"
      />
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { CertificationModelVM } from "@/models/certificationService";
import type {
  DisbursementModelVM,
  DisbursementSummaryItemModel,
} from "@/models/disbursementService";
import { computed } from "vue";
import DisbursementSummaryItem from "./DisbursementSummaryItem.vue";

const props = defineProps<{
  certification: CertificationModelVM;
  disbursements: DisbursementModelVM[];
}>();

const disbursementSummary = (disbursement: DisbursementModelVM) => {
  return `${disbursement?.estimatedDisbursementDate} | ${disbursement?.disbursementAmount} | ${disbursement?.details?.status}`;
};

const disbursementHeader = (index: number) => {
  return `Disbursement ${index + 1}`;
};

const disbursementSummaries = computed<DisbursementSummaryItemModel[]>(() => {
  if (props.disbursements && props.disbursements?.length > 0) {
    return props.disbursements.map((d: DisbursementModelVM, index: number) => {
      return {
        id: `Cert${index}${d.sequenceNumber}`,
        header: disbursementHeader(index),
        details: disbursementSummary(d),
      };
    });
  }

  return [];
});
</script>
<style scoped src="@/styles/certification-updates/base.css"></style>
<style scoped src="@/styles/certification-updates/disbursements.css"></style>
